import { Icon, Typography } from "@bonprix/design-system";
import React from "react";
import { capitalizeWords } from "../../helper/text-case.js";
import { HighlightedText } from "./HighlightedText.jsx";

export const SearchResultItem = ({ searchTerm, value,listMode, isActive, selectionMode, onSelect, id, onMouseOver }) => {
    let className = '';
    if (isActive) {
        if (selectionMode === 'HOVER') {
            className = 'hover';
        }
        if (selectionMode === 'SELECT') {
            className = 'active';
        }
    }

    return (
        <li
            id={id}
            role="option"
            aria-selected={isActive}
            className={`search__result-item ${className}`}
            onClick={(e) => {
                e.preventDefault();
                onSelect(value);
            }}
            onMouseDown={(e) => e.preventDefault()}
            onMouseEnter={onMouseOver}
        >
            <div className={'search__result-item-container'}>
                <Icon variant="search" />
                <div className="search__result_item-label">
                    <Typography variant="subtitle1" component="span">
                        {listMode === 'SUGGESTIONS' ? (
                            <HighlightedText text={capitalizeWords(value)} highlight={searchTerm} />
                        ) : (
                            capitalizeWords(value)
                        )}
                    </Typography>
                </div>
            </div>
        </li>
    );
};
